import "./employer-update-items";
import "./participant-update-items";

import autoloadActionItemComponents from './autoload'

autoloadActionItemComponents();


// WEBPACK FOOTER //
// ./src/action-items/types/registered-types.js